document.addEventListener("DOMContentLoaded", () => {
  const menuTrigger = document.querySelector(".custom-tsf-class-menu-hello");
  const megaMenuWrapper = document.querySelector(".header__megamenu__wrapper");
  const blurOverlay = document.querySelector(".page-blury-overlay");
  const crossIcon = document.querySelector(".header-drop-down-close.js-drop-down-close"); // Your cross icon

  if (menuTrigger && megaMenuWrapper) {
    menuTrigger.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      megaMenuWrapper.classList.toggle("active");
      if (blurOverlay) {
        blurOverlay.classList.toggle("is-visible");
      }
      document.body.classList.toggle("overflow-hidden");
      if (crossIcon) {
        crossIcon.classList.toggle("active");
      }
    });
    document.addEventListener("click", (e) => {
      if (!megaMenuWrapper.contains(e.target) && !menuTrigger.contains(e.target)) {
        megaMenuWrapper.classList.remove("active");
        if (blurOverlay) {
          blurOverlay.classList.remove("is-visible");
        }
        document.body.classList.remove("overflow-hidden");
        if (crossIcon) {
          crossIcon.classList.remove("active");
        }
      }
    });
  }
});
